import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ActiveCompartmentsModel } from '../../../store/state/monitoring/allocation-view';
import { UliActivityType } from '../../../common/constants';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { DirectivesModule } from '../../../common/directives/directives.module';
@Component({
  selector: 'ui-compartment-select',
  imports: [
    CommonModule,
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule,
  ],
  templateUrl: './compartment-select.component.html',
  styleUrls: ['./compartment-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompartmentSelectComponent<T extends { fullAddress: string }, U> {
  @Input() fieldLabel: string;
  @Input() fieldControl: FormControl<T>;
  @Input() filterControl?: FormControl<U>;
  @Input() testId: string;
  @Input() disabled: boolean;
  @Input() compartmentList: ActiveCompartmentsModel[];
  @Input() activityType: UliActivityType;
}
